var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minimize"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C9.55228 4 10 4.44772 10 5V7C10 7.79565 9.68393 8.55871 9.12132 9.12132C8.55871 9.68393 7.79565 10 7 10H5C4.44772 10 4 9.55228 4 9C4 8.44772 4.44772 8 5 8H7C7.26522 8 7.51957 7.89464 7.70711 7.70711C7.89464 7.51957 8 7.26522 8 7V5C8 4.44772 8.44772 4 9 4ZM15 4C15.5523 4 16 4.44772 16 5V7C16 7.26522 16.1054 7.51957 16.2929 7.70711C16.4804 7.89464 16.7348 8 17 8H19C19.5523 8 20 8.44772 20 9C20 9.55228 19.5523 10 19 10H17C16.2043 10 15.4413 9.68393 14.8787 9.12132C14.3161 8.55871 14 7.79565 14 7V5C14 4.44772 14.4477 4 15 4ZM4 15C4 14.4477 4.44772 14 5 14H7C7.79565 14 8.55871 14.3161 9.12132 14.8787C9.68393 15.4413 10 16.2043 10 17V19C10 19.5523 9.55228 20 9 20C8.44772 20 8 19.5523 8 19V17C8 16.7348 7.89464 16.4804 7.70711 16.2929C7.51957 16.1054 7.26522 16 7 16H5C4.44772 16 4 15.5523 4 15ZM17 16C16.7348 16 16.4804 16.1054 16.2929 16.2929C16.1054 16.4804 16 16.7348 16 17V19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19V17C14 16.2043 14.3161 15.4413 14.8787 14.8787C15.4413 14.3161 16.2043 14 17 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H17Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.db4e6807bc8dd0bc0df890ca1d9d376d.svg";
export { ForwardRef as ReactComponent };